import { FC } from "react";

interface Props {
  filterItems: {
    value: string;
    label: string;
  }[];
  onFilterChange: (filterValue: string) => void;
}

export const Filter: FC<Props> = ({ filterItems, onFilterChange }) => (
  <select
    name="settingKey"
    id="settingKey"
    onChange={(event) => onFilterChange(event.target.value)}
  >
    {filterItems.map((filterItem) => (
      <option key={filterItem.value} value={filterItem.value}>
        {filterItem.label}
      </option>
    ))}
  </select>
);
